import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import FAQ from './components/FAQ';
import Privacy from './components/Privacy';
import Contact from './components/Contact';
import Instructions from './components/Instructions';
import ScrollToTop from './components/ScrollToTop';

import RecipeDetailPage from './components/RecipeDetailPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/instructions" element={<Instructions />} />
          <Route path="/recipe/:recipeId" element={<RecipeDetailPage />} />
          <Route path="/share/:token" element={<RecipeDetailPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
